import {Trans} from '../../i18n/trans';
import {Button} from '../buttons/button';
import {Link} from 'react-router-dom';
import {IllustratedMessage} from '../images/illustrated-message';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-24">
      <IllustratedMessage
        size="lg"
        image={
          <img
            src="/assets/images/icons/404.gif"
            alt="Page Not Found"
            className="max-w-[600px] w-full"
          />
        }
        imageHeight="h-auto"
        title={<Trans message="Page Not Found" />}
        description={
          <Trans message="Sorry, that page doesn't exist." />
        }
        action={
          <Button
            elementType={Link}
            to="/"
            variant="flat"
            color="primary"
            size="lg"
          >
            <Trans message="Go to Homepage" />
          </Button>
        }
      />
    </div>
  );
}
